export default __webpack_public_path__ + "static/finding_apartment_icon-91b9d460fb4c8a68efe911435eeabb4f.svg";